/*----- Core -----*/
import React 					 from 'react'
import styled, { css } from 'styled-components'
import PropTypes       from 'prop-types'

/*----- Commons -----*/
import Montserrat from '../../commons/mixins/fonts/Montserrat'
import Device     from '../../commons/Device'
import Color      from '../../commons/Color'

/*----- Styles -----*/
const StyledSectionTitle = styled.h2`

	max-width: 700px;
	width: 100%;
	${ Montserrat( 30, 700, Color.tertiary)}
	line-height: 44px;
	padding: 0 16px;

	@media ${ Device.sm } {
		font-size: 50px;
		line-height: 54px;
	}
	${props => props.invert && css`
		color: white;
  `}

`

/*----- Component -----*/
function SectionTitle({ content, invert}) {
	return (
		<StyledSectionTitle className="section-title" invert={invert? 1 : 0}>{ content }</StyledSectionTitle>
	)
}

export default SectionTitle

/*----- PropTypes -----*/
SectionTitle.propTypes = {
  content: PropTypes.string.isRequired,
  invert:  PropTypes.bool
}
